/**
 * Compatibility layer for existing imports.
 * The webpack entry point is main.js. Scenes that need the Phaser config
 * or the shared gameState can import from here.
 */
import getConfig from '@config/baseConfig';

const config = getConfig();

const gameState = {
  correctAttempt: false,
  confirmClick: false,
  cardDown: true,
  wrongAttempt: 0,
  wrongState: false,
  hintClose: false,
  correctCount: 0,
  wrongCount: 0,
  hintAttempted: 0,
  retry: false,
  cam: null,
  gameWin: false,
  totalAttempted: 0,
  questionNo: 2,
};

export { config, gameState };
